@if (
  {
    onboarding: onboardingSummary$ | async,
    activity: activity(),
    isSubmitting: isSubmitting()
  };
  as STATE
) {
  <main class="onboarding-summary">
    <hgroup>
      <h2>Récapitulatif de vos informations</h2>
      <p>
        Voici les informations fournies lors de votre inscription. Veuillez les
        vérifier avant de poursuivre.
      </p>
    </hgroup>

    <section class="onboarding-summary__card">
      <article class="onboarding-summary__card-item">
        <h2>1. Information sur l'entreprise</h2>
        <ul class="onboarding-summary__card-item__content">
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              NCC :
              {{ STATE?.onboarding?.currentUser?.organization?.nif }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Raison sociale :
              {{ STATE?.onboarding?.currentUser?.organization?.name }}
            </span>
          </li>

          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Régime d'imposition :
              {{ STATE?.onboarding?.currentUser?.organization?.taxSystem }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Direction de rattachement :
              {{ STATE?.onboarding?.currentUser?.organization?.taxDirection }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Centre d'impôts :
              {{ STATE?.onboarding?.currentUser?.organization?.taxCenter }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Statut DGI :
              {{ STATE?.onboarding?.currentUser?.organization?.statusLabel }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Numéro de téléphone :
              {{ STATE?.onboarding?.location?.phoneNumber }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Adresse e-mail :
              {{ STATE?.onboarding?.location?.email }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Activité :
              {{ STATE.activity?.label }}
            </span>
          </li>
        </ul>
      </article>

      <mat-divider class="form__divider"></mat-divider>

      <article class="onboarding-summary__card-item">
        <h2>2. Gestionnaire Principal</h2>
        <ul class="onboarding-summary__card-item__content">
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Nom & Prénoms : {{ STATE.onboarding?.currentUser?.firstName }}
              {{ STATE?.onboarding?.currentUser?.lastName }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Adresse e-mail : {{ STATE?.onboarding?.currentUser?.email }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Numéro de téléphone :
              {{ STATE?.onboarding?.currentUser?.phoneNumber }}
            </span>
          </li>
        </ul>
      </article>

      <mat-divider class="form__divider"></mat-divider>

      <article class="onboarding-summary__card-item">
        <h2>3. Localisation du siège social</h2>
        <ul class="onboarding-summary__card-item__content">
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span> Ville : {{ STATE.onboarding?.location?.city ?? '-' }} </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span> Commune : {{ STATE.onboarding?.location?.district }} </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Quartier : {{ STATE.onboarding?.location?.neighborhood }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span> Adresse : {{ STATE.onboarding?.location?.location }} </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Coordonnées GPS :
              {{ STATE.onboarding?.location?.longitude }} ;
              {{ STATE.onboarding?.location?.latitude }}
            </span>
          </li>
          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Téléphone :
              {{ STATE.onboarding?.location?.phoneNumber }}
            </span>
          </li>

          <!--  <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Nom ou Prénom(s) / Raison social du Propriétaire du bâtiment :
              {{ STATE.onboarding?.location?.siteOwnerName || '-' }}
            </span>
          </li>

          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Nif du Propriétaire du bâtiment :
              {{ STATE.onboarding?.location?.siteOwnerNif || '-' }}
            </span>
          </li>

          <li>
            <mat-icon svgIcon="dgi-list-marker" aria-hidden="true"></mat-icon>
            <span>
              Numéro de téléphone du Propriétaire du bâtiment :
              {{ STATE.onboarding?.location?.siteOwnerPhoneNumber || '-' }}
            </span>
          </li> -->
        </ul>
      </article>

      <mat-divider class="form__divider"></mat-divider>

      <article
        class="onboarding-summary__card-item onboarding-summary__card-item--equipments"
      >
        <h2>4. Équipements de facturation (si déclarés)</h2>
        <ul class="onboarding-summary__card-item__content">
          @for (
            billingEquipment of STATE.onboarding?.billingEquipment?.equipments;
            track $index
          ) {
            <li class="equipment-item">
              @if (billingEquipment.type) {
                <div>
                  <p aria-hidden="true">
                    <mat-icon svgIcon="dgi-list-marker"></mat-icon>
                  </p>
                  <p>
                    <span
                      >Type d'équipement :
                      {{ billingEquipment.type | referenceDataType }}
                    </span>
                  </p>
                </div>
              }

              @if (billingEquipment.name || billingEquipment.otherValue) {
                <div>
                  <p aria-hidden="true">
                    <mat-icon svgIcon="dgi-list-marker"></mat-icon>
                  </p>
                  <p>
                    <span>
                      Désignation :
                      {{
                        billingEquipment.name === 'Autres' ||
                        billingEquipment.type === 'Autres'
                          ? billingEquipment.otherValue || 'Autres'
                          : billingEquipment.name
                      }}
                    </span>
                  </p>
                </div>
              }
            </li>
          }

          @if (STATE.onboarding?.billingEquipment?.cashRegistersNumber) {
            <li>
              <div>
                <mat-icon
                  svgIcon="dgi-list-marker"
                  aria-hidden="true"
                ></mat-icon>
                <span>
                  Caisses enregistreuses :
                  {{
                    STATE.onboarding?.billingEquipment?.cashRegistersNumber ??
                      '-'
                  }}
                </span>
              </div>
            </li>
          }
        </ul>
      </article>
    </section>

    <section class="onboarding-summary__terms-of-use" (click)="toggleConsent()">
      <p>
        En activant ce bouton, je confirme avoir lu et accepté les
        <span class="highlight">
          <a href="/cgu" target="_ blank" rel="noopener noreferrer"
            >Conditions Générales d’Utilisation</a
          ></span
        >
        de la plateforme, et j’atteste de l’exactitude des informations fournies
        lors de mon inscription.
      </p>
      <mat-slide-toggle
        [checked]="hasUserConsented"
        (click)="$event.stopPropagation(); toggleConsent()"
      ></mat-slide-toggle>
    </section>
    <hr />
    <section class="form__actions onboarding-summary__actions">
      <button
        type="button"
        class="btn btn-outline-primary onboarding-summary__actions--btn-prev"
        (click)="handlePrevStep()"
      >
        <mat-icon svgIcon="dgi-arrow-left"></mat-icon>
        <span class="onboarding-summary__actions--label">Précédent</span>
      </button>

      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!hasUserConsented || STATE.isSubmitting"
        [attr.loading]="STATE.isSubmitting"
        (click)="onSubmit()"
      >
        Activer mon compte
      </button>
    </section>
  </main>
}
